// Shown when Sign in with Apple succeeds but the identity token carries no email, so the
// server answers `{ requiresEmail: true }` instead of creating a session (see
// server/routes/auth.js's /auth/apple step 4).
//
// This is not an edge case. Apple releases the email and name ONLY on the very first
// authorization for a given Apple ID + app, so every later sign-in arrives without them —
// and `users.email` is UNIQUE NOT NULL, so an account can't be created without one. Anyone
// whose first authorization didn't result in an account (including every user who tried
// while the client was requesting no scopes at all, the Guideline 2.1(a) bug fixed
// 2026-09-18) can only get in through this step.
//
// Lives in its own component because Login.js and Register.js both need it, same as the
// buttons in SocialAuthButtons.js.
export default function AppleEmailPrompt({ email, onEmailChange, onSubmit, onCancel, error, busy }) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Agence</h1>
        <h2>One more step</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '1rem' }}>
          Apple didn&apos;t share an email address with us this time — it only does that the
          first time you use Sign in with Apple. Enter the email you&apos;d like on your
          account to finish signing in.
        </p>
        <form onSubmit={onSubmit}>
          <input
            type="email"
            placeholder="Email"
            aria-label="Email address"
            value={email}
            onChange={onEmailChange}
            autoFocus
            required
            disabled={busy}
          />
          {error && <p className="error">{error}</p>}
          <button type="submit" disabled={busy || !email.trim()}>
            {busy ? 'Finishing…' : 'Finish signing in'}
          </button>
        </form>
        <button
          onClick={onCancel}
          style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '0.85rem', marginTop: '0.75rem', display: 'block' }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
